import { forwardRef, type ComponentProps, type ReactNode } from 'react';
import { cn } from '@/lib/utils';
import FieldLabelMobile from '@/domains/mobile-web/components/FieldLabelMobile/FieldLabelMobile';

export interface InputMobileProps extends Omit<ComponentProps<'input'>, 'className'> {
    label?: string;
    error?: string;
    helperText?: string;
    rightIcon?: ReactNode;
    /** class untuk pembungkus (label + field) */
    className?: string;
    /** class tambahan untuk elemen input */
    inputClassName?: string;
}

const InputMobile = forwardRef<HTMLInputElement, InputMobileProps>(
    ({ label, error, helperText, rightIcon, className, inputClassName, id, name, required, ...props }, ref) => {
        const inputId = id ?? name;

        return (
            <FieldLabelMobile
                label={label}
                htmlFor={inputId}
                required={required}
                error={error}
                helperText={helperText}
                className={className}
            >
                <div className="relative w-full">
                    <input
                        ref={ref}
                        id={inputId}
                        name={name}
                        required={required}
                        aria-invalid={!!error}
                        className={cn('field-mobile', rightIcon && 'pr-11', error && 'field-mobile-error', inputClassName)}
                        {...props}
                    />
                    {rightIcon && (
                        <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-black">
                            {rightIcon}
                        </span>
                    )}
                </div>
            </FieldLabelMobile>
        );
    }
);

InputMobile.displayName = 'InputMobile';

export default InputMobile;
